"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var Item_1 = __importDefault(require("./Item"));
var ActivityCard = function (props) {
    // 解析props属性
    var className = props.className, style = props.style, _a = props.ActivityList, ActivityList = _a === void 0 ? [] : _a;
    // 获取样式的通用前缀
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var prefixClassName = "".concat(classPrefix, "-activity");
    return (react_1.default.createElement("section", { style: style, className: (0, classnames_1.default)(className, prefixClassName) },
        react_1.default.createElement("div", { className: "".concat(prefixClassName, "__list") }, ActivityList.map(function (item, index) { return (react_1.default.createElement(Item_1.default, __assign({ key: index }, item))); }))));
};
ActivityCard.displayName = 'ActivityCard';
exports.default = ActivityCard;
//# sourceMappingURL=ActivityCard.js.map